import landingGuard from '@/guards/landingGuard';
import companyRegisterRedirectGuard from '@/guards/companyRegisterRedirectGuard';

export default {
    name: 'home',
    component: () => import(/* webpackChunkName: "auth-layout" */ '@/layouts/BlankLayout.vue'),
    children: [
        {
            path: '',
            name: 'landing-page',
            meta: { marketing: true },
            beforeEnter: [landingGuard],
            component: () => import(/* webpackChunkName: "landing-page" */ '@/modules/principal/views/LandingPageV5.vue'),
        },
        {
            path: 'login',
            name: 'login-page',
            // beforeEnter: [hasAccessGuard],
            // component: () => import(/* webpackChunkName: "landing-page" */ '@/modules/principal/views/login.vue'),
            beforeEnter: [landingGuard],
            component: () => import(/* webpackChunkName: "login-page" */ '@/modules/principal/views/LandingPageV5.vue'),
        },
        {
            path: 'questions',
            name: 'questions-page',
            component: () => import(/* webpackChunkName: "questions-page" */ '@/modules/principal/views/Questions.vue'),
        },
        {
            path: 'reasons',
            name: 'reasons-page',
            component: () => import(/* webpackChunkName: "reasons-page" */ '@/modules/principal/views/ReasonsForConsultation.vue'),
        },
        {
            path: 'partner',
            name: 'partner-page',
            component: () => import(/* webpackChunkName: "partner-page" */ '@/modules/principal/views/Partner.vue'),
        },
        {
            path: 'im-psychologist',
            name: 'im-psychologist-page',
            component: () => import(/* webpackChunkName: "partner-page" */ '@/modules/principal/views/ImPsychologist.vue'),
        },
        {
            path: 'psicologo/:psychologiLink',
            name: 'schedule-appointment-external',
            component: () => import(/* webpackChunkName: "schedule-appointment" */ '@/modules/appointments/views/AppointmentWrapper.vue')
        },
        {
            path: 'privacy-notice',
            name: 'privacy-notice',
            beforeEnter: () => {
                const base = process.env.VUE_APP_RESILIENCIA_DOMAIN
                const normalized = base ? String(base).replace(/\/$/, '') : ''
                window.location.href = `${normalized}/privacy-notice`
                return false
            },
            component: () => import(/* webpackChunkName: "privacy-notice" */ '@/modules/principal/views/PrivacyNotice.vue')
        },
        {
            path: 'terms',
            name: 'terms-and-conditions',
            beforeEnter: () => {
                const base = process.env.VUE_APP_RESILIENCIA_DOMAIN
                const normalized = base ? String(base).replace(/\/$/, '') : ''
                window.location.href = `${normalized}/terms-and-conditions-of-use`
                return false
            },
            component: () => import(/* webpackChunkName: "privacy-notice" */ '@/modules/privacy/views/TermsAndConditions.vue')
        },
        {
            path: 'familia',
            name: 'landing-page-family',
            meta: { marketing: true },
            //beforeEnter: [landingGuard],
            component: () => import(/* webpackChunkName: "landing-page" */ '@/modules/principal/views/LandingPageV5.vue'),
        },
        {
            path: 'personal',
            name: 'personal-lading-page',
            component: () => import(/* webpackChunkName: "reasons-page" */ '@/modules/principal/views/LandingPageV3.vue'),
        },
        {
            path: 'landing-v4',
            name: 'landing-v4',
            component: () => import(/* webpackChunkName: "reasons-page" */ '@/modules/principal/views/LandingPageV4.vue'),
        },
        {
            path: 'life-line',
            name: 'landing-life-line',
            beforeEnter: [landingGuard],
            component: () => import(/* webpackChunkName: "landing-life-line" */ '@/modules/waiting-room/views/LifeLine.vue')
        },
        {
            path: '404',
            name: 'not-found',
            component: () => import(/* webpackChunkName: "not-found" */ '@/modules/principal/views/NotFound.vue'),
        },
        {
            path: 'preguntas-frecuentes',
            name: 'preguntas-frecuentes',
            meta: { marketing: true },
            component: () => import(/* webpackChunkName: "preguntas-frecuentes" */ '@/modules/principal/views/PreguntasFrecuentes.vue'),
        },
        {
            path: 'recursos',
            // Vue Router fusiona meta de padre a hijos: aplica a todos los artículos
            meta: { marketing: true },
            component: () => import(/* webpackChunkName: "recursos" */ '@/modules/principal/views/recursos/RecursosLayout.vue'),
            children: [
                {
                    path: '',
                    name: 'recursos',
                    component: () => import(/* webpackChunkName: "recursos" */ '@/modules/principal/views/recursos/RecursosIndex.vue'),
                },
                {
                    path: 'nom-035-guia-para-empresas',
                    name: 'recursos-nom-035',
                    component: () => import(/* webpackChunkName: "recursos-nom-035" */ '@/modules/principal/views/recursos/Nom035Guia.vue'),
                },
                {
                    path: 'presentismo-burnout-costo-empresas',
                    name: 'recursos-presentismo-burnout',
                    component: () => import(/* webpackChunkName: "recursos-presentismo" */ '@/modules/principal/views/recursos/PresentismoBurnout.vue'),
                },
                {
                    path: 'bienestar-emocional-para-empresas',
                    name: 'recursos-bienestar-emocional',
                    component: () => import(/* webpackChunkName: "recursos-bienestar" */ '@/modules/principal/views/recursos/BienestarEmocional.vue'),
                },
                {
                    path: 'alternativa-programa-asistencia-empleado',
                    name: 'recursos-alternativa-pae',
                    component: () => import(/* webpackChunkName: "recursos-pae" */ '@/modules/principal/views/recursos/AlternativaPae.vue'),
                },
                {
                    path: 'metodologia-modelo-de-atencion',
                    name: 'recursos-metodologia',
                    component: () => import(/* webpackChunkName: "recursos-metodologia" */ '@/modules/principal/views/recursos/MetodologiaAtencion.vue'),
                },
                {
                    path: 'medir-roi-bienestar-emocional',
                    name: 'recursos-medir-roi',
                    component: () => import(/* webpackChunkName: "recursos-roi" */ '@/modules/principal/views/recursos/MedirRoi.vue'),
                },
                {
                    path: 'de-un-beneficio-a-una-estrategia',
                    name: 'recursos-beneficio-estrategia',
                    component: () => import(/* webpackChunkName: "recursos-estrategia" */ '@/modules/principal/views/recursos/BeneficioEstrategia.vue'),
                },
            ],
        },
        {
            // Catch-all de un segmento: solo tenants válidos redirigen a app.mimente.com
            path: ':tenantName',
            name: 'landing-page-company-register',
            beforeEnter: [companyRegisterRedirectGuard],
            component: () => import(/* webpackChunkName: "landing-page" */ '@/modules/principal/views/LandingPageV5.vue'),
        },
    ]
}
